import { useEffect } from "react";
export const useComponentDidMount = callback => {
  /* eslint-disable */
  useEffect(callback, []);
};
